"use strict";

exports.__esModule = true;
exports.ALL_ENTITY_TYPES = exports.POST_ENTITY_TYPES = exports.ENTITY_TYPE_COMMENTS = exports.ENTITY_TYPE_MANAGE_POSTS_TRASH = exports.ENTITY_TYPE_MANAGE_POSTS_SCHEDULED = exports.ENTITY_TYPE_MANAGE_POSTS_PUBLISHED = exports.ENTITY_TYPE_MANAGE_POSTS_DRAFTS = exports.ENTITY_TYPE_POSTS = void 0;

var _post = require("@wix/communities-blog-universal/dist/src/constants/post");

var ENTITY_TYPE_POSTS = 'posts';
exports.ENTITY_TYPE_POSTS = ENTITY_TYPE_POSTS;
var ENTITY_TYPE_MANAGE_POSTS_DRAFTS = "posts-" + _post.POST_STATUS.unpublished;
exports.ENTITY_TYPE_MANAGE_POSTS_DRAFTS = ENTITY_TYPE_MANAGE_POSTS_DRAFTS;
var ENTITY_TYPE_MANAGE_POSTS_PUBLISHED = "posts-" + _post.POST_STATUS.published;
exports.ENTITY_TYPE_MANAGE_POSTS_PUBLISHED = ENTITY_TYPE_MANAGE_POSTS_PUBLISHED;
var ENTITY_TYPE_MANAGE_POSTS_SCHEDULED = "posts-" + _post.POST_STATUS.scheduled;
exports.ENTITY_TYPE_MANAGE_POSTS_SCHEDULED = ENTITY_TYPE_MANAGE_POSTS_SCHEDULED;
var ENTITY_TYPE_MANAGE_POSTS_TRASH = "posts-" + _post.POST_STATUS.deleted;
exports.ENTITY_TYPE_MANAGE_POSTS_TRASH = ENTITY_TYPE_MANAGE_POSTS_TRASH;
var ENTITY_TYPE_COMMENTS = 'comments';
exports.ENTITY_TYPE_COMMENTS = ENTITY_TYPE_COMMENTS;
var POST_ENTITY_TYPES = [ENTITY_TYPE_POSTS, ENTITY_TYPE_MANAGE_POSTS_DRAFTS, ENTITY_TYPE_MANAGE_POSTS_PUBLISHED, ENTITY_TYPE_MANAGE_POSTS_SCHEDULED, ENTITY_TYPE_MANAGE_POSTS_TRASH];
exports.POST_ENTITY_TYPES = POST_ENTITY_TYPES;
var ALL_ENTITY_TYPES = [ENTITY_TYPE_COMMENTS].concat(POST_ENTITY_TYPES);
exports.ALL_ENTITY_TYPES = ALL_ENTITY_TYPES;